<template>
  <div class="bg">
    <headline :params="headLines"></headline>
    <div class="main">
      <div class="content">
        <p class="title">
          <input v-model="title" type="text" placeholder="请输入标题" maxlength="60">
          <span class="counting">
            {{`${title.length}/60`}}
          </span>
        </p>
        <!-- 图片上传 -->
        <div class="up">
          <span class="type">
            {{pic.title}}
          </span>
          <div class="right">
            <p class="guide">
              {{pic.description}}
            </p>
            <div class="upload">
              <label class="trigger" id="picBtn">
                <img src="@assets/img/upload/add.svg" alt="add">
                <!-- <input @change="receiveFiles(uploadData.pic, $event)" type="file" name="xPic" id="xPic" multiple="multiple" accept="image/*"> -->
                <span>上传图片</span>
              </label>
              <div class="wrapper">
                <div class="loaders">
                  <div class="item" v-for="(p, i) in pic.list" :key="i" v-if="p.available">
                    <!-- <img class="play" src="@assets/img/upload/play.svg" alt="play"> -->
                    <img class="bger" src="@assets/img/common/default.png" alt="内容">
                    <div class="mask" v-if="p.percent>=0 && p.percent<100">
                      <div class="process">
                        <p class="stage" :style="{width: p.percent + '%'}"></p>
                      </div>
                    </div>
                    <img class="del" src="@assets/img/upload/del.svg" alt="del" @click="pic.cancelOne(p.id)">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 视频上传 -->
        <div class="up">
          <span class="type">
            {{video.title}}
          </span>
          <div class="right">
            <div class="selection">
              <div :class="{option: true, active: video.onChannel === c}" v-for="(c, i) in video.channels" :key="i" @click="video.switchChannel(c)">
                <span class="icon">
                  <span class="dot"></span>
                </span>
                <span>{{c}}</span>
              </div>
            </div>
            <p class="guide">
              {{video.description}}
            </p>
            <div class="upload">
              <div class="global" v-if="video.onChannel === '国际通道'" @click="goAspera()">
                <p class="btn">
                  <img src="@assets/img/upload/notice.svg" alt="notice">
                  <span>下载插件</span>
                </p>
              </div>
              <label class="trigger" id="videoBtn">
                <img src="@assets/img/upload/add.svg" alt="add">
                <span>上传视频</span>
                <!-- <input @change="receiveFiles(uploadData.video, $event)" type="file" name="xVideo" id="xVideo" multiple="multiple" accept="video/*"> -->
              </label>
              <div class="wrapper">
                <div class="loaders">
                  <div class="item" v-for="(p, i) in video.list" :key="i" v-if="p.available">
                    <img class="play" v-if="p.percent === 100" src="@assets/img/upload/play.svg" alt="play">
                    <img class="bger" src="@assets/img/common/default.png" alt="内容">
                    <div class="mask" v-if="p.percent>=0 && p.percent<100">
                      <div class="process">
                        <p class="stage" :style="{width: p.percent + '%'}"></p>
                      </div>
                    </div>
                    <img class="del" src="@assets/img/upload/del.svg" alt="del" @click="video.cancelOne(p.id)">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 音频上传 -->
        <div class="up">
          <span class="type">
            音频
          </span>
          <div class="right">
            <p class="guide">
              支持mp3,wma,wav,amr,文件大小不超过20M，语言时长不超过30分钟
            </p>
            <div class="upload">
              <label class="trigger" id="audioBtn">
                <!-- <input type="file" name="" id=""> -->
                <img src="@assets/img/upload/add.svg" alt="add">
                <span>上传音频</span>
                <!-- <input @change="receiveFiles(uploadData.audio, $event)" type="file" name="xAudio" id="xAudio" multiple="multiple" accept="audio/*"> -->
              </label>
              <div class="wrapper">
                <div class="loaders">
                  <div class="item" v-for="(p, i) in audio.list" :key="i" v-if="p.available">
                    <img v-if="p.percent === 100" class="play" src="@assets/img/upload/play.svg" alt="play">
                    <img class="bger" src="@assets/img/common/default.png" alt="内容">
                    <div class="mask" v-if="p.percent>=0 && p.percent<100">
                      <div class="process">
                        <p class="stage" :style="{width: p.percent + '%'}"></p>
                      </div>
                    </div>
                    <img class="del" src="@assets/img/upload/del.svg" alt="del" @click="audio.cancelOne(p.id)">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
     </div>
     <div class="inside">
       <div class="toInside">to 内网</div>
     </div>
    </div>
    <imgEditor />
  </div>
</template>

<script>
import headline from '@components/headline'
import * as config from '@common/config'
import common from '@common/common'
import imgEditor from '@components/imgEditor'

export default {
  name: 'upload',
  components: {
    headline, imgEditor
  },
  data() {
    return {
      isXnew: true,
      headLines: {
        title: '文件to内网',
        showLink: false,
        filter: false
      },
      title: '',
      baseUrl: '',
      appId: '',
      appSecret: '',
      baseConfig: {
        customered: true,
        autoUploading: true,
        multipleFiles: true,
        retryCount: 3,
        tokenURL: '',
        uploadURL: '',
        postVarsPerFile : {
            appId:'',
            appSecret: ''
        },
        onMaxSizeExceed: (f) => {
          console.log('exceed', f)
          this.$toast('文件大小超出限制')
        },
        onCancel: (f) => {
          console.log('cancel', f)
        },
        onExtNameMismatch: () => {
          this.$toast('所选文件格式有误')
        }
      },
      pic: {
        // 图片部分数据模型
        title: '图片',
        description: '图片默认格式：jpg、png、gif等，建议单个大小不超过20MB',
        stream: null,
        list: [],
        cancelOne: (id) => {
          if (this.pic.stream) {
            this.pic.stream.cancelOne(id)
            this.delItem(this.pic.list, id)
          }
        },
        config: {
          browseFileId: 'picBtn',
          extFilters: ['.jpg', '.png', '.gif'],
          maxSize: 20*1024*1024,
          onQueueComplete: (m) => {
            this.$toast('所有图片已上传完成')
          },
          onUploadError: (f) => {
            this.$toast('图片上传出错')
          },
          onSelect: (f) => {
            setTimeout(() => {
              // 获取等待队列及正在上传文件（当autoupload为true时），整合所有已选文件放到数据模型中
              const waiting = Array.from(this.pic.stream.waiting)
              const loading = this.getUploadingOne(this.pic.stream.uploadInfo)

              if (loading) {
                waiting.unshift(loading)
              }

              const totalList = this.pic.list.concat(f)
              this.pic.list = Array.from(new Set(totalList))
              this.checkWaiting(this.pic.list, waiting)
            }, 0)
          },
          onUploadProgress: (f) => {
            this.handleProgress(this.pic.list, f)
          }
        }
      },
      video: {
        // 视频部分数据模型
        title: '视频',
        description: 'vob,avi,wmv,mp4,mpg,f4v,rmvb,flv,mkv,webm,ogv,3gp,m2t,m4v,mov,asf,wav,aac,caf等，单个不超过10GB',
        stream: null,
        list: [],
        channels: [
          '国际通道', '国内通道'
        ],
        onChannel: '国内通道',
        switchChannel: (c) => {
          // 切换通道
          this.video.onChannel = c
        },
        cancelOne: (id) => {
          if (this.video.stream) {
            this.video.stream.cancelOne(id)
            this.delItem(this.video.list, id)
          }
        },
        config: {
          browseFileId: 'videoBtn',
          extFilters: ['.vob', '.avi', '.wmv', '.mp4', '.mpg', '.f4v', '.rmvb', '.flv', '.mkv', '.webm', '.ogv', '.3gp', '.m2t', '.m4v', '.mov', '.asf', '.wav', '.aac', '.caf'],
          maxSize: 10*1024*1024*1024,
          onQueueComplete: (m) => {
            this.$toast('所有视频已上传完成')
          },
          onUploadError: (f) => {
            this.$toast('视频上传出错')
          },
          onSelect: (f) => {
            setTimeout(() => {
              const waiting = Array.from(this.video.stream.waiting)
              const loading = this.getUploadingOne(this.video.stream.uploadInfo)

              if (loading) {
                waiting.unshift(loading)
              }

              const totalList = this.video.list.concat(f)
              this.video.list = Array.from(new Set(totalList))
              this.checkWaiting(this.video.list, waiting)
            }, 0)
          },
          onUploadProgress: (f) => {
            this.handleProgress(this.video.list, f)
          }
        }
      },
      audio: {
        // 音频部分数据模型
        title: '音频',
        description: '支持mp3,wma,wav,amr,文件大小不超过20M，语言时长不超过30分钟',
        stream: null,
        list: [],
        cancelOne: (id) => {
          if (this.audio.stream) {
            this.audio.stream.cancelOne(id)
            this.delItem(this.audio.list, id)
          }
        },
        config: {
          browseFileId: 'audioBtn',
          extFilters: ['.mp3', '.wma', '.wav', '.amr'],
          maxSize: 20*1024*1024,
          onQueueComplete: (m) => {
            this.$toast('所有音频已上传完成')
          },
          onUploadError: (f) => {
            this.$toast('音频上传出错')
          },
          onSelect: (f) => {
            setTimeout(() => {
              const waiting = Array.from(this.audio.stream.waiting)
              const loading = this.getUploadingOne(this.audio.stream.uploadInfo)

              if (loading) {
                waiting.unshift(loading)
              }

              const totalList = this.audio.list.concat(f)
              this.audio.list = Array.from(new Set(totalList))
              this.checkWaiting(this.audio.list, waiting)
            }, 0)
          },
          onUploadProgress: (f) => {
            this.handleProgress(this.audio.list, f)
          }
        }
      }
    }
  },
  methods: {
    init() {
      // 模块初始化
      this.load().then(() => {
        this.configPic()
        this.configVideo()
        this.configAudio()
      })
    },
    load() {
      // 加载js文件
      // return common.load(config.streamjs)
      return Promise.all([common.load(config.streamjs), this.getConfig()])
    },
    getConfig() {
      return common.getFileConfigs()
      .then(r => {
        this.baseUrl = r.url
        this.appId = r.app_id
        this.appSecret = r.app_secret

        const dataConfig = {
          tokenURL: this.baseUrl + config.apis.File_get_token,
          uploadURL: this.baseUrl + config.apis.File_post,
          postVarsPerFile : {
              appId: this.appId,
              appSecret: this.appSecret
          }
        }

        Object.assign(this.baseConfig, dataConfig)
        return true
      })
    },
    checkWaiting(l, w) {
      // 检查所选文件大小，符合条件的加入队列 (设为可见)
      w.forEach(i => {
        l.forEach( t => {
          if (t.id === i) {
            this.$set(t, 'available', true)
          }
        })
      })
    },
    handleProgress(l, f) {
      // 控制进度条
      l.forEach(i => {
        if (i.available && i.id === f.id) {
          console.log('progress', i)
          this.$set(i, 'percent', f.percent)
        }
      })
    },
    configPic() {
      // 配置图片
      const config = Object.assign({}, this.baseConfig, this.pic.config, common.userKeys())
      console.log(123321, config)
      this.pic.stream = new Stream(config)
    },
    configVideo() {
      // 配置视频
      const config = Object.assign({}, this.baseConfig, this.video.config, common.userKeys())

      this.video.stream = new Stream(config)
    },
    configAudio() {
      // 配置音频
      const config = Object.assign({}, this.baseConfig, this.audio.config, common.userKeys())

      this.audio.stream = new Stream(config)
    },
    delItem(data, id) {
      // 从数组中移除取消上传的项
      data.forEach((d, i) => {
        if (d.id === id) {
          data.splice(i, 1)
        }
      })
    },
    getUploadingOne(all) {
      // 从uploadinfo中查找正在上传选项并返回
      let one = null
      for (let k in all) {
        if (all.hasOwnProperty(k)) {
          if (all[k].actived) {
            one = k
          }
        }
      }

      return one
    },
    goAspera() {
      // 去aspera插件的下载页
      const url = config.asperajs

      window.open(url, '', '', true)
    }
  },
  created() {
    this.init()
    let domin = window.document.domain;
    let isXnew = true;
    if(domin.indexOf('xnews')!=-1){
      isXnew = true
    }else if(domin.indexOf('localhost')!=-1){
      isXnew = true
    }else{
      isXnew = false
    }
    this.isXnew = isXnew;
  }
}
</script>

<style lang="less" src='@assets/css/upload.less' scoped></style>
